/**
 * Messenger Store (Zustand)
 *
 * Global state for the messenger UI.
 * Manages selected conversation, search, modals, and mobile view state.
 */

import { create } from 'zustand';

const useMessengerStore = create((set) => ({
  // Selected conversation
  selectedConversationId: null,
  selectedConversation: null,

  // Mobile view: 'inbox' or 'thread'
  mobileView: 'inbox',

  // Search
  searchQuery: '',

  // Modals
  newConversationModalOpen: false,

  // Reply-to state
  replyingTo: null,

  // Actions
  selectConversation: (conversation) => set({
    selectedConversationId: conversation?.id || null,
    selectedConversation: conversation,
    mobileView: conversation ? 'thread' : 'inbox'
  }),

  clearSelection: () => set({
    selectedConversationId: null,
    selectedConversation: null,
    mobileView: 'inbox'
  }),

  setMobileView: (view) => set({ mobileView: view }),

  setSearchQuery: (query) => set({ searchQuery: query }),

  openNewConversationModal: () => set({ newConversationModalOpen: true }),
  closeNewConversationModal: () => set({ newConversationModalOpen: false }),

  setReplyingTo: (message) => set({ replyingTo: message }),
  clearReplyingTo: () => set({ replyingTo: null })
}));

export default useMessengerStore;
